module.exports = __webpack_public_path__ + "static/media/20_000008.f79162a1.jpg";